module.exports = __webpack_public_path__ + "img/Logo.45c632f2.svg";